import { Injectable, Inject } from '@angular/core';
import { Http, Response } from '@angular/http';
//import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';


@Injectable()
export class LanguageService {
    constructor(private _http: Http,
        @Inject('Claims') private _claims: any) {
    }

    public supportedLanguages: any[] = [
        { "iso639_1": "en", "iso639_2": "eng", "name": "English", "nativeName": "English (United States)" },
        { "iso639_1": "sv", "iso639_2": "swe", "name": "Swedish", "nativeName": "svenska" },
        { "iso639_1": "pt", "iso639_2": "por", "name": "Portuguese", "nativeName": "Português (Brasil)" },
        { "iso639_1": "ru", "iso639_2": "rus", "name": "Russian", "nativeName": "Русский" },
        { "iso639_1": "es", "iso639_2": "spa", "name": "Spanish", "nativeName": "Español" },
        { "iso639_1": "nl", "iso639_2": "nld", "name": "Dutch", "nativeName": "Nederlands" },
        { "iso639_1": "de", "iso639_2": "deu", "name": "German", "nativeName": "Deutsch" },
        { "iso639_1": "fr", "iso639_2": "fra", "name": "French", "nativeName": "français" },
        { "iso639_1": "zh", "iso639_2": "zho", "name": "Chinese", "nativeName": "中文 (Zhōngwén)" },
        { "iso639_1": "el", "iso639_2": "ell", "name": "Greek (modern)", "nativeName": "ελληνικά" },
        { "iso639_1": "tr", "iso639_2": "tur", "name": "Turkish", "nativeName": "Türkçe" },
        { "iso639_1": "cs", "iso639_2": "ces", "name": "Czech", "nativeName": "čeština" },
        { "iso639_1": "fi", "iso639_2": "fin", "name": "Finnish", "nativeName": "suomi" },
        { "iso639_1": "it", "iso639_2": "ita", "name": "Italian", "nativeName": "Italiano" },
        { "iso639_1": "hu", "iso639_2": "hun", "name": "Hungarian", "nativeName": "magyar" },
        { "iso639_1": "ja", "iso639_2": "jpn", "name": "Japanese", "nativeName": "日本語 (にほんご)" },
        { "iso639_1": "sl", "iso639_2": "slv", "name": "Slovene", "nativeName": "slovenski jezik" },
        { "iso639_1": "vi", "iso639_2": "vie", "name": "Vietnamese", "nativeName": "Tiếng Việt" }
    ];
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Services/LanguageService.ts